// extracted by mini-css-extract-plugin
export default {"biobar-country":"styles_biobar-country__kSo-W","biobar-current-locale":"styles_biobar-current-locale__ndpBu","biobar-current":"styles_biobar-current__KmVvu"};